import { render, staticRenderFns } from "./PwaPrompt.vue?vue&type=template&id=05bd0bc8&scoped=true"
import script from "./PwaPrompt.vue?vue&type=script&lang=js"
export * from "./PwaPrompt.vue?vue&type=script&lang=js"
import style0 from "./PwaPrompt.vue?vue&type=style&index=0&id=05bd0bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd0bc8",
  null
  
)

export default component.exports